import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/index';
import { persistMiddleware } from '../reducers/slice/toggleSlice'; // Adjust the path as necessary
import { persistVideoToggleMiddleware } from '../reducers/slice/videoToggleSlice';

const middleware = [thunk, persistMiddleware, persistVideoToggleMiddleware];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;